import PropTypes from 'prop-types';

const SearchZoomInSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 40}`}
      height={`${height || 40}`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M19.1693 35C27.9138 35 35.0026 27.9112 35.0026 19.1666C35.0026 10.4221 27.9138 3.33331 19.1693 3.33331C10.4248 3.33331 3.33594 10.4221 3.33594 19.1666C3.33594 27.9112 10.4248 35 19.1693 35Z"
        fill={color}
      />
      <path
        d="M35.4964 36.6667C35.1964 36.6667 34.8964 36.55 34.6797 36.3333L31.5797 33.2333C31.1297 32.7833 31.1297 32.05 31.5797 31.5833C32.0297 31.1333 32.763 31.1333 33.2297 31.5833L36.3297 34.6833C36.7797 35.1333 36.7797 35.8667 36.3297 36.3333C36.0964 36.55 35.7964 36.6667 35.4964 36.6667Z"
        fill={color}
      />
      <path
        d="M23.6693 18.25H20.7526V15.3333C20.7526 14.65 20.1859 14.0833 19.5026 14.0833C18.8193 14.0833 18.2526 14.65 18.2526 15.3333V18.25H15.3359C14.6526 18.25 14.0859 18.8166 14.0859 19.5C14.0859 20.1833 14.6526 20.75 15.3359 20.75H18.2526V23.6666C18.2526 24.35 18.8193 24.9166 19.5026 24.9166C20.1859 24.9166 20.7526 24.35 20.7526 23.6666V20.75H23.6693C24.3526 20.75 24.9193 20.1833 24.9193 19.5C24.9193 18.8166 24.3526 18.25 23.6693 18.25Z"
        fill={color}
      />
    </svg>
  );
};

SearchZoomInSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default SearchZoomInSvg;
